export const normalizeAbn = (value) =>
  value == null ? value : String(value).replace(/\s/g, "");
export const formatAbn = (value) =>
  String(normalizeAbn(value) ?? "").replace(
    /^(\d{2})(\d{3})(\d{3})(\d{3})$/,
    "$1 $2 $3 $4"
  );
